import { useState, useEffect } from 'react'

const useForm = (initialValues, callback, validate) => {
  const [canSubmit, setCanSubmit] = useState(true)
  const [values, setValues] = useState({ ...initialValues })
  const [valuesToSubmit, setValuesToSubmit] = useState(null)
  const [input, setInput] = useState(null)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      setSubmitting(false)
      valuesToSubmit ? callback(valuesToSubmit, input) : callback(values)
    }
    // eslint-disable-next-line
  }, [errors])

  const onSubmitForm = event => {
    if (event) {
      event.preventDefault()
    }
    if (!valuesToSubmit) {
      setErrors(validate(values))
    }
    setSubmitting(true)
  }

  const clearCurrentErrors = current => {
    delete errors[current]
    setErrors(errors)
  }

  const updateValues = ({ name, value }) => {
    setValues(currentValues => ({
      ...currentValues,
      [name]: value,
    }))
    setInput(name)
  }

  const handleChange = ({ name, value }) => {
    setCanSubmit(true)
    setSubmitting(false)
    clearCurrentErrors(name)
    updateValues({ name, value })
  }

  const handleSubmitValues = (values, inputName) => {
    setCanSubmit(false)
    setValuesToSubmit(values)
    setErrors(validate(values, inputName))
    setSubmitting(true)
  }

  return {
    canSubmit,
    handleChange,
    onSubmitForm,
    values,
    valuesToSubmit,
    errors,
    setErrors,
    updateValues,
    handleSubmitValues,
  }
}

export default useForm
